"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedbagsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedbagsm` : '') + (description ? ` desc-brandedbagsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedbagsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedbagsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.86 10.84V3.86a2.76 2.76 0 1 0-5.51 0v6.98a2.76 2.76 0 0 0 5.5 0ZM10.1 0a3.86 3.86 0 0 0-3.86 3.86v6.98a3.86 3.86 0 1 0 7.72 0V3.86A3.86 3.86 0 0 0 10.1 0Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M20.54 4.86a.6.6 0 0 0-.1-.56.67.67 0 0 0-.53-.26H.66c-.21 0-.4.1-.53.26a.62.62 0 0 0-.1.56l3.46 12.77c.08.27.3.37.6.37H16.3c.3 0 .55-.18.63-.45l3.6-12.7Z",
    fill: "#F26B1C"
  }));
};
var _default = exports.default = brandedbagsm;